// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'AkkuratLL', 'AkkuratLL Fallback'"},"className":"__className_c77f08","variable":"__variable_c77f08"};